import { render, staticRenderFns } from "./EditSucai.vue?vue&type=template&id=b13d82de&scoped=true"
import script from "./EditSucai.vue?vue&type=script&lang=js"
export * from "./EditSucai.vue?vue&type=script&lang=js"
import style0 from "./EditSucai.vue?vue&type=style&index=0&id=b13d82de&prod&lang=css"
import style1 from "./EditSucai.vue?vue&type=style&index=1&id=b13d82de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d82de",
  null
  
)

export default component.exports